import http from "@/http-common";
import httpMultipart from "@/http-multipart";

const BASE = "/evaluation/periodic";

function toFormData(data) {
  const formData = new FormData();

  const append = (key, value) => {
    if (value === undefined || value === null) return;
    if (typeof Blob !== "undefined" && value instanceof Blob) {
      formData.append(key, value);
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((item, index) => append(`${key}[${index}]`, item));
      return;
    }
    if (typeof value === "object") {
      Object.entries(value).forEach(([childKey, childValue]) => {
        append(`${key}.${childKey}`, childValue);
      });
      return;
    }
    formData.append(key, String(value));
  };

  Object.entries(data || {}).forEach(([key, value]) => append(key, value));
  return formData;
}

class PeriodicEvaluationService {
  // ─── CRUD ───────────────────────────────────────
  create(data) {
    return httpMultipart.post(BASE, toFormData(data));
  }

  update(data) {
    return httpMultipart.put(BASE, toFormData(data));
  }

  delete(data) {
    return http.delete(BASE, { data });
  }

  // ─── Approve ────────────────────────────────────
  approve(data) {
    return http.put(`${BASE}/approve`, data);
  }

  // ─── Reply ──────────────────────────────────────
  createReply(data) {
    return http.post(`${BASE}/reply`, data);
  }

  updateReply(data) {
    return http.put(`${BASE}/reply`, data);
  }

  deleteReply(params) {
    return http.delete(`${BASE}/reply`, { params });
  }

  // ─── Read state ─────────────────────────────────
  markRead(data) {
    return http.put(`${BASE}/mark-read`, data);
  }

  markRepliesRead(data) {
    return http.put(`${BASE}/reply/mark-read`, data);
  }

  getActivityLog(params) {
    return http.get(`${BASE}/activity-log`, { params });
  }

  // ─── Query ──────────────────────────────────────
  getByStudent(params) {
    return http.get(`${BASE}/by-student`, { params });
  }

  getByClass(params) {
    return http.get(`${BASE}/by-class`, { params });
  }
}

export default new PeriodicEvaluationService();
